import { Opts } from "../types";

type InjectableService = {
  getAll: (opts: Opts) => Promise<{ [key: string]: any }[]>;
};

type InjectableServiceOptions = {
  idPropName?: string;
  labelPropName?: string;
};

export const nullOptionInjector = (svc: InjectableService, svcOptions?: InjectableServiceOptions) => {
  let nullResult: { [key: string]: any } = {};
  if (!!svcOptions?.idPropName)
    nullResult[svcOptions.idPropName] = null;
  else 
    nullResult.id = null;
  
  if (!!svcOptions?.labelPropName)
    nullResult[svcOptions.labelPropName] = "";
  else
    nullResult.label = "";

  const newFunc = (opts: Opts) => 
    new Promise<{[key: string]: any}[]>((resolve) => {
      svc.getAll(opts)
        .then(innerRes => {
          resolve([ nullResult, ...innerRes ]);
        });
    }
  );

  return {
    getAll: newFunc
  };
};